import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'
import { Trip } from '@types'

interface TripsResponse {
	trips: Trip[]
}

export const useTrips = () => {
	return useQuery<TripsResponse>({
		queryKey: queryKeys.trips(),
		queryFn: async () => {
			const response = await api.get<TripsResponse>('/trips')
			return response.data
		},
		retry: 1,
	})
}
